module.exports = "../fonts/vendor/vendor/typeface-poppins/files/poppins-latin-300.woff?5c5aa25747e329a14d9ab8be881cbe02";